<template>
  <div class="menu">
    <div class="pb-3 pt-1">
      <b-card bg-variant="gra-pu-bl" class="my-2 border-transparent-app">

        <template #header>
          <h4 class="text-center mb-0">Pre-order Menu</h4>
        </template>

        <b-button variant="light" block @click="$router.push('/Route?target=OrderList&uriType=pod')"
          class="mb-1 pl-2 text-left">
          <!-- <f-icon :style="{ color: randomColor }" icon="store"></f-icon> -->
          <img :src="picSVG['ecommerce']" class="icon-menu-svg"/>
          รายการข้อมูลพรีออร์เดอร์ <!-- v-if="countNotification[menu.uri] !== '0'" -->
          <b-badge variant="danger" class="right-badge" v-if="userData.userType === 'A' && countNotification.PreOrder !== '0'"> {{ countNotification.PreOrder }} </b-badge>
        </b-button>

        <!-- <b-button variant="light" block @click="$router.push('/Route?target=OrderTransport&uriType=pod')"
          class="mb-1 pl-2 text-left">
          <f-icon :style="{ color: randomColor }" icon="truck-moving"></f-icon>
          <i> แนบบิลขนส่งจากร้านจีน</i> (ยังไม่เปิดให้บริการ)
        </b-button> -->

      </b-card>

      <!-- <hr v-if="userData.userType === 'A'" /> -->

      <b-card bg-variant="gra-ye-pu" class="my-2 border-transparent-app">

        <template #header>
          <h4 class="text-center mb-0">Shipping Menu</h4>
        </template>

        <template v-if="userData.userType === 'A'">
          <b-button v-for="menu in menuAdmin" :key="menu.id"
          variant="light" block @click="$router.push('/Route?target=' + menu.uri + '&uriType=' + menu.uriType)"
          class="mb-1 pl-2 text-left">
          <!-- <f-icon :style="{ color: randomColor }" :icon="menu.icon"></f-icon> -->
          <img :src="picSVG[menu.icon]" class="icon-menu-svg"/>
          {{ menu.message }} <b-badge variant="danger" v-if="menu.haveNotification && countNotification[menu.uri] !== '0'" class="right-badge"> {{ countNotification[menu.uri] }} </b-badge>
          </b-button>
        </template>

        <template v-if="userData.userType === 'U'">
          <b-button v-for="menu in menuUser" :key="menu.id"
          variant="light" block @click="$router.push('/Route?target=' + menu.uri + '&uriType=' + menu.uriType)"
          class="mb-1 pl-2 text-left">
          <img :src="picSVG[menu.icon]" class="icon-menu-svg"/>
          {{ menu.message }}
          </b-button>
        </template>

        <b-button v-for="menu in menuItems" :key="menu.id"
        variant="light" block @click="$router.push('/Route?target=' + menu.uri + '&uriType=' + menu.uriType)"
        class="mb-1 pl-2 text-left">
        <img :src="picSVG[menu.icon]" class="icon-menu-svg"/>
        {{ menu.message }} <b-badge variant="danger" v-if="menu.haveNotification && userData.userType === 'A' && countNotification[menu.uri] !== '0'" class="right-badge">{{ countNotification[menu.uri] }}</b-badge>
        </b-button>

      </b-card>
      <!-- <hr> -->

      <b-card bg-variant="gra-ye-gr" class="text-center mb-2 border-transparent-app">
        <template v-if="dataReady && vipReady">
          <h4>VIP Member</h4>
          <h2 class="mb-0">
            <img :src="picSVG[userData.vipName]" class="icon-svg"/>
            {{ userData.vipName }}
          </h2>
        </template>
        <template v-if="dataReady && !vipReady">
          <h4>แต้มสะสมของคุณ</h4>
          <h3 class="mb-0">
            <img :src="require('@/assets/svg/chip_point.svg')" class="icon-svg"/> {{ userPoint }} แต้ม
          </h3>
        </template>

        <h2 v-if="!dataReady"><f-icon icon="spinner" pulse></f-icon></h2>
      </b-card>

      <b-card bg-variant="gra-gr-bl" class="text-center mb-2 border-transparent-app">
        <h4>ยอดเงินคงเหลือรวม</h4>
        <!-- :class="(userBalance > 0 ? 'text-success' : 'text-danger') +'animate__animated animate__rubberBand'" -->
        <h3 v-if="dataReady"
          class="animate__animated animate__rubberBand mb-0"
          >
          <img :src="require('@/assets/svg/money_1.svg')" class="icon-svg" /> {{ exportBalance }} บาท
        </h3>
        <h2 v-if="!dataReady"><f-icon icon="spinner" pulse></f-icon></h2>
        <!-- <h4>บาท</h4> -->
        <!-- <h6 v-if="dataReady" class="text-primary">ยอดเงินสั่งสินค้า <b class="animate__animated animate__rubberBand">{{ preBalance ? preBalance : 0 }} บาท</b></h6> -->
        <!-- <h6 v-if="dataReady" class="text-info">ยอดเงินขนส่ง <b class="animate__animated animate__rubberBand">{{ exportBalance ? exportBalance : 0 }} บาท</b></h6> -->
      </b-card>

      <div class="text-center">
        <h6><b-badge v-if="dataReady" @click="getDataUserBalance()"><f-icon icon="sync-alt"></f-icon> refresh</b-badge></h6>
      </div>

      <hr>
      <p>เรทนำเข้าสินค้าจากจีน</p>
      <!-- <b-img-lazy center rounded  class="w-100 my-2" src="https://firebasestorage.googleapis.com/v0/b/trackingpreorder.appspot.com/o/new_price_20032023%2FnewPrice%20(4).jpg?alt=media&token=d375bbfd-5930-490a-8b19-6490b90fdcae"></b-img-lazy> -->
      <b-img-lazy center rounded  class="w-100 my-2" src="https://firebasestorage.googleapis.com/v0/b/trackingpreorder.appspot.com/o/newprice_0424%2Flicm_track_0424.jpg?alt=media&token=f2f2c4be-1329-4c73-a87a-365489fc1ef7"></b-img-lazy>
      <b-img-lazy center rounded  class="w-100 my-2" src="https://firebasestorage.googleapis.com/v0/b/trackingpreorder.appspot.com/o/newLicm%2Fpricenb2.jpg?alt=media&token=3c499cf6-90ce-4758-a155-9bc59fc7d13c"></b-img-lazy>

      <hr>
      <div class="text-center">
        ติดต่อสอบถามแอดไลน์ LICM Cargo

        <b-img center
          :src="require('@/assets/QRCode.jpg')"
          width="180px"
          height="180px" class="my-2"></b-img>

        <a href="https://lin.ee/NUGqMkp">
          <img src="https://scdn.line-apps.com/n/line_add_friends/btn/th.png" alt="เพิ่มเพื่อน" height="30" border="0">
        </a>
      </div>

      <hr>
      <b-button @click="logoutUser" pill block size="lg"><f-icon icon="sign-out-alt"></f-icon> Log out</b-button>
    </div>
  </div>
</template>

<script>
import axios from "axios"; // api
export default {
  name: "MenuBar",
  mounted() {
    // จะเกิดขึ้นเมื่อ DOM ถูกสร้างเสร็จแล้ว เราสามารถ เข้าถึง Element ต่างๆใน DOM ได้ทั้งหมด
    // เช่นการ ดึงข้อมูลจาก input เป็นต้น
    // let memberJsonData = localStorage.getItem('memberData')
    // if (memberJsonData) {
    //   this.userData = JSON.parse(memberJsonData)
    // }
    this.userData = this.getDataStorageUser()
    this.getDataUserBalance()

    if (this.userData.userType === 'A') {
      this.getDataNotification()
    }

    this.randomColor = "#" + Math.floor(Math.random()*255).toString(16) + Math.floor(Math.random()*100).toString(16) + Math.floor(Math.random()*255).toString(16)
  },
  data() {
    return {
      msg: "Welcome to Your Vue.js App",
      dataReady: false,
      vipReady: false,
      userData: {
        userName: '',
        firstName: '',
        lastName: '',
        telephoneNumber: '',
        userType: '',
        vipName: ''
      },
      randomColor: "#212529",
      userVIP: "Basic",
      userBalance: 0.01,
      preBalance: 0.01,
      exportBalance: 0.01,
      userPoint: 0,
      countNotification: {
        Tracking: 0,
        Refill: 0,
        Transport: 0,
        PreOrder: 0,
      },
      menuItems: [
        {
          id: 1000,
          message: 'สมุดบัญชี',
          uriType: 'User',
          uri: 'Revenue',
          haveNotification: true,
          icon: 'revenue'
        },
        {
          id: 1001,
          message: 'รายการรหัสพัสดุ',
          uriType: 'User',
          uri: 'Tracking',
          haveNotification: true,
          icon: 'invoice'
        },
        {
          id: 1003,
          message: 'รายการสั่งออกสินค้า',
          uriType: 'User',
          uri: 'Delivery',
          icon: 'delivery-truck'
        },
        {
          id: 1004,
          message: 'ประวัติรหัสพัสดุ',
          uriType: 'User',
          uri: 'History',
          icon: 'time-manage'
        }
      ],
      menuUser: [
        {
          id: 4999,
          message: 'แดชบอร์ด',
          uriType: 'User',
          uri: 'Dashboard',
          icon: 'dashboardWeb'
        },
        {
          id: 5000,
          message: 'แจ้งเติมเงิน',
          uriType: 'User',
          uri: 'TopUp',
          icon: 'loan'
        },
        {
          id: 5001,
          message: 'ตั้งค่าบัญชีผู้ใช้',
          uriType: 'User',
          uri: 'Profile',
          icon: 'user-cog'
        },
        {
          id: 5002,
          message: 'สั่งออกรหัสพัสดุ',
          uriType: 'User',
          uri: 'Export',
          icon: 'container'
        },
        // {
        //   id: 5003,
        //   message: 'แจ้งชำระเงิน',
        //   uriType: 'User',
        //   uri: 'Payment',
        //   icon: 'file-invoice-dollar'
        // },
        {
          id: 5004,
          message: 'ประวัติการเติมเงิน',
          uriType: 'User',
          uri: 'HistoryTopUp',
          icon: 'file-invoice-dollar'
          // icon: 'search-dollar'
        },
      ],
      menuAdmin: [
        {
          id: 9001,
          message: 'รายการบัญชีผู้ใช้',
          uriType: 'Admin',
          uri: 'Accounts',
          icon: 'users'
        },
        {
          id: 9002,
          message: 'จัดการประกาศ',
          uriType: 'Admin',
          uri: 'Announce',
          icon: 'comment'
        },
        {
          id: 9003,
          message: 'อนุมัติรายการเติมเงิน',
          uriType: 'Admin',
          uri: 'Refill',
          haveNotification: true,
          icon: 'money-bag'
        },
        {
          id: 9004,
          message: 'แนบบิลขนส่ง',
          uriType: 'Admin',
          uri: 'Transport',
          haveNotification: true,
          icon: 'file-invoice-dollar'
        },
      ]
    };
  },
  methods: {
    showAlert () {
      // Use sweetalert2
      this.$swal("Hello Vue world!!!");
    },
    getDataUserBalance () {
      this.dataReady = false
      axios
        .get(
          // eslint-disable-next-line quotes
          'https://licm-cargo.com/api/User/User_balance?userName=' +
          this.userData.userName,
          {
            headers: this.getHeaderAPI('User_balance', this.userData.userName)
          }
        )
        .then((response) => {
          let rs = response.data
          if (rs.status === true){
            this.userBalance = rs.total_balance
            this.preBalance = rs.pre_balance
            this.exportBalance = rs.export_balance
            // this.userBalance = parseFloat(rs.balance)
            this.dataReady = true;
          } else {
            this.userBalance = 0
            this.preBalance = 0
            this.exportBalance = 0
            this.$swal("ผิดพลาด","ไม่สามารถเรียกดูเงินคงเหลือของท่าน กรุณาติดต่อแอดมิน","error")
            this.dataReady = true;
          }

          // this.getDataUserVIP()
          if (this.userData.vipName) {
            this.vipReady = true;
          } else {
            this.getDataUserPoint()
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          this.userBalance = 0
          this.preBalance = 0
          this.exportBalance = 0
          this.$swal("ผิดพลาด","ไม่สามารถเรียกดูเงินคงเหลือของท่าน : " + error,"error")
          this.dataReady = true;
          // this.errored = true
        });
    },
    // getDataUserVIP () {
    //   this.dataReady = false

    //   axios
    //     .get(
    //       // eslint-disable-next-line quotes
    //       'https://licm-cargo.com/api/User/User_point?userName=' +
    //       this.userData.userName,
    //       {
    //         headers: this.getHeaderAPI('User_point', this.userData.userName)
    //       }
    //     )
    //     .then((response) => {
    //       let rs = response.data
    //       if (rs.status === true){
    //         this.userVIP = rs.vipName
    //         this.dataReady = true;
    //         this.vipReady = true;
    //       } else {
    //         this.dataReady = true;
    //         this.vipReady = false;

    //         this.getDataUserPoint()
    //       }
    //     })
    //     // eslint-disable-next-line handle-callback-err
    //     .catch((error) => {
    //       this.$swal("ผิดพลาด","ไม่สามารถดึงข้อมูล VIP","error")
    //       this.dataReady = true;
    //       this.vipReady = false;

    //       this.getDataUserPoint()
    //       // this.errored = true
    //     });
    // },
    getDataUserPoint () {
      this.vipReady = false
      this.dataReady = false

      axios
        .get(
          // eslint-disable-next-line quotes
          'https://licm-cargo.com/api/User/User_point?userName=' +
          this.userData.userName,
          {
            headers: this.getHeaderAPI('User_point', this.userData.userName)
          }
        )
        .then((response) => {
          let rs = response.data
          if (rs.status === true){
            this.userPoint = rs.point
            this.dataReady = true;
          } else {
            this.userPoint = 0
            // this.$swal("ผิดพลาด","ไม่พบข้อมูลแต้มส่วนลดของท่าน กรุณาติดต่อแอดมิน","error")
            this.dataReady = true;
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          this.userPoint = 0
          this.$swal("ผิดพลาด","ไม่สามารถดูแต้มส่วนลดของท่าน กรุณาติดต่อแอดมิน","error")
          this.dataReady = true;
          // this.errored = true
        });
    },
    getDataNotification () {
      this.dataReady = false
      axios
        .get(
          // eslint-disable-next-line quotes
          'https://licm-cargo.com/api/Authen/notification',
          {
            headers: this.getHeaderAPI('Notification')
          }
        )
        .then((response) => {
          let rs = response.data
          if (rs.status === true){
            this.countNotification.Tracking = rs.data.countInvoice
            this.countNotification.Refill = rs.data.countSlipTopUp
            this.countNotification.Transport = rs.data.countDeliver
            this.countNotification.PreOrder = rs.data.countTrackPre || '0'

          } else {
            this.$swal("ผิดพลาด","ไม่สามารถเรียกดูแจ้งเตือนได้","error")
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          this.$swal("ผิดพลาด","ไม่สามารถเรียกดูแจ้งเตือนได้: "+ error,"error")
          // this.errored = true
        });
    },
    logoutUser () {
      this.$router.push('/Login')
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .btn-light:not(:hover){
    background-color: transparent;
    border-color: transparent;
    border-radius: 0rem 0.8rem 0.8rem 0rem;
    border-left: 0px #30303000 solid;
    transition: border-left 0.2s, background-color 0.2s;
  }

  .btn-light:hover{
    background-color: rgba(255, 255, 255, 0.70);
    border-color: transparent;
    border-left: 3px #30303070 solid;
    border-radius: 0rem 0.8rem 0.8rem 0rem;
    /* background-image: linear-gradient(to right,#e2e6ea30,#e2e6ea80); */
  }
  .right-badge{
    float: right;
    top: 3px !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/Menubar.vue